import { Component, Input } from '@angular/core';

@Component({ standalone: false,
  selector: 'interactions-counter',
  templateUrl: './interactions-counter.component.html',
  styleUrls: ['./interactions-counter.component.css']
})
export class InteractionsCounterComponent {
  @Input() total: number = 0;
}